@file:OptIn(InternalResourceApi::class)

package fr.frux.app.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.app.resources/"

@delegate:ResourceContentHash(2_032_538_014)
internal val Res.string.favorites_add_label: StringResource by lazy {
      StringResource("string:favorites_add_label", "favorites_add_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 59),
      ))
    }

@delegate:ResourceContentHash(-1_829_925_100)
internal val Res.string.favorites_empty_cta: StringResource by lazy {
      StringResource("string:favorites_empty_cta", "favorites_empty_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 70, 51),
      ))
    }

@delegate:ResourceContentHash(-655_036_645)
internal val Res.string.favorites_empty_message: StringResource by lazy {
      StringResource("string:favorites_empty_message", "favorites_empty_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122, 139),
      ))
    }

@delegate:ResourceContentHash(-63_024_991)
internal val Res.string.favorites_empty_title: StringResource by lazy {
      StringResource("string:favorites_empty_title", "favorites_empty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 262, 57),
      ))
    }

@delegate:ResourceContentHash(247_139_158)
internal val Res.string.favorites_remove_label: StringResource by lazy {
      StringResource("string:favorites_remove_label", "favorites_remove_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 320, 62),
      ))
    }

@delegate:ResourceContentHash(1_219_665_128)
internal val Res.string.favorites_sites_title: StringResource by lazy {
      StringResource("string:favorites_sites_title", "favorites_sites_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 383, 45),
      ))
    }

@delegate:ResourceContentHash(1_886_018_066)
internal val Res.string.favorites_title: StringResource by lazy {
      StringResource("string:favorites_title", "favorites_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 429, 35),
      ))
    }

@delegate:ResourceContentHash(-922_221_827)
internal val Res.string.harvests_domain_note: StringResource by lazy {
      StringResource("string:harvests_domain_note", "harvests_domain_note", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 465, 112),
      ))
    }

@delegate:ResourceContentHash(-221_732_650)
internal val Res.string.harvests_find_tree_cta: StringResource by lazy {
      StringResource("string:harvests_find_tree_cta", "harvests_find_tree_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 578, 54),
      ))
    }

@delegate:ResourceContentHash(-1_039_046_639)
internal val Res.string.harvests_full: StringResource by lazy {
      StringResource("string:harvests_full", "harvests_full", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 633, 33),
      ))
    }

@delegate:ResourceContentHash(1_946_803_229)
internal val Res.string.harvests_hosted_by_owner: StringResource by lazy {
      StringResource("string:harvests_hosted_by_owner", "harvests_hosted_by_owner", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 667, 44),
      ))
    }

@delegate:ResourceContentHash(1_580_441_687)
internal val Res.string.harvests_intro: StringResource by lazy {
      StringResource("string:harvests_intro", "harvests_intro", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 712, 186),
      ))
    }

@delegate:ResourceContentHash(896_278_687)
internal val Res.string.harvests_open: StringResource by lazy {
      StringResource("string:harvests_open", "harvests_open", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 899, 29),
      ))
    }

@delegate:ResourceContentHash(-1_093_466_325)
internal val Res.string.harvests_participants_cueilleur_plural: StringResource by lazy {
      StringResource("string:harvests_participants_cueilleur_plural", "harvests_participants_cueilleur_plural", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 929, 66),
      ))
    }

@delegate:ResourceContentHash(-1_093_466_417)
internal val Res.string.harvests_participants_cueilleur_singular: StringResource by lazy {
      StringResource("string:harvests_participants_cueilleur_singular", "harvests_participants_cueilleur_singular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 996, 68),
      ))
    }

@delegate:ResourceContentHash(174_141_557)
internal val Res.string.harvests_participants_with_max: StringResource by lazy {
      StringResource("string:harvests_participants_with_max", "harvests_participants_with_max", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1065, 70),
      ))
    }

@delegate:ResourceContentHash(-1_264_947_770)
internal val Res.string.harvests_place_clear_description: StringResource by lazy {
      StringResource("string:harvests_place_clear_description", "harvests_place_clear_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1136, 60),
      ))
    }

@delegate:ResourceContentHash(1_229_918_150)
internal val Res.string.harvests_place_clear_query_description: StringResource by lazy {
      StringResource("string:harvests_place_clear_query_description", "harvests_place_clear_query_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1197, 74),
      ))
    }

@delegate:ResourceContentHash(2_047_033_383)
internal val Res.string.harvests_place_empty_hint: StringResource by lazy {
      StringResource("string:harvests_place_empty_hint", "harvests_place_empty_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1272, 157),
      ))
    }

@delegate:ResourceContentHash(93_682_799)
internal val Res.string.harvests_place_field_placeholder: StringResource by lazy {
      StringResource("string:harvests_place_field_placeholder", "harvests_place_field_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1430, 88),
      ))
    }

@delegate:ResourceContentHash(1_532_670_936)
internal val Res.string.harvests_place_selected: StringResource by lazy {
      StringResource("string:harvests_place_selected", "harvests_place_selected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1519, 51),
      ))
    }

@delegate:ResourceContentHash(-948_365_729)
internal val Res.string.harvests_step1_body: StringResource by lazy {
      StringResource("string:harvests_step1_body", "harvests_step1_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1571, 159),
      ))
    }

@delegate:ResourceContentHash(-210_228_933)
internal val Res.string.harvests_step1_title: StringResource by lazy {
      StringResource("string:harvests_step1_title", "harvests_step1_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1731, 84),
      ))
    }

@delegate:ResourceContentHash(-1_130_161_898)
internal val Res.string.harvests_step2_body: StringResource by lazy {
      StringResource("string:harvests_step2_body", "harvests_step2_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1816, 183),
      ))
    }

@delegate:ResourceContentHash(-855_350_641)
internal val Res.string.harvests_step2_title: StringResource by lazy {
      StringResource("string:harvests_step2_title", "harvests_step2_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2000, 60),
      ))
    }

@delegate:ResourceContentHash(-1_559_466_044)
internal val Res.string.harvests_step3_body: StringResource by lazy {
      StringResource("string:harvests_step3_body", "harvests_step3_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2061, 171),
      ))
    }

@delegate:ResourceContentHash(1_677_868_820)
internal val Res.string.harvests_step3_title: StringResource by lazy {
      StringResource("string:harvests_step3_title", "harvests_step3_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2233, 56),
      ))
    }

@delegate:ResourceContentHash(1_276_571_385)
internal val Res.string.harvests_subtitle: StringResource by lazy {
      StringResource("string:harvests_subtitle", "harvests_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2290, 93),
      ))
    }

@delegate:ResourceContentHash(-1_957_023_911)
internal val Res.string.harvests_title: StringResource by lazy {
      StringResource("string:harvests_title", "harvests_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2384, 34),
      ))
    }

@delegate:ResourceContentHash(-2_003_528_437)
internal val Res.string.harvests_zone_map_center: StringResource by lazy {
      StringResource("string:harvests_zone_map_center", "harvests_zone_map_center", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2419, 72),
      ))
    }

@delegate:ResourceContentHash(-1_174_093_364)
internal val Res.string.harvests_zone_zoomed_out: StringResource by lazy {
      StringResource("string:harvests_zone_zoomed_out", "harvests_zone_zoomed_out", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2492, 88),
      ))
    }

@delegate:ResourceContentHash(300_421_537)
internal val Res.string.install_banner_action: StringResource by lazy {
      StringResource("string:install_banner_action", "install_banner_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2581, 41),
      ))
    }

@delegate:ResourceContentHash(1_707_039_062)
internal val Res.string.install_banner_close: StringResource by lazy {
      StringResource("string:install_banner_close", "install_banner_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2623, 36),
      ))
    }

@delegate:ResourceContentHash(466_587_109)
internal val Res.string.install_banner_subtitle: StringResource by lazy {
      StringResource("string:install_banner_subtitle", "install_banner_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2660, 67),
      ))
    }

@delegate:ResourceContentHash(1_217_265_007)
internal val Res.string.install_banner_title: StringResource by lazy {
      StringResource("string:install_banner_title", "install_banner_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2728, 52),
      ))
    }

@delegate:ResourceContentHash(854_815_724)
internal val Res.string.mytrees_empty_cta: StringResource by lazy {
      StringResource("string:mytrees_empty_cta", "mytrees_empty_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2781, 49),
      ))
    }

@delegate:ResourceContentHash(-1_523_760_095)
internal val Res.string.mytrees_empty_message: StringResource by lazy {
      StringResource("string:mytrees_empty_message", "mytrees_empty_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2831, 105),
      ))
    }

@delegate:ResourceContentHash(-987_641_522)
internal val Res.string.mytrees_empty_title: StringResource by lazy {
      StringResource("string:mytrees_empty_title", "mytrees_empty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2937, 55),
      ))
    }

@delegate:ResourceContentHash(-763_281_757)
internal val Res.string.mytrees_title: StringResource by lazy {
      StringResource("string:mytrees_title", "mytrees_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2993, 37),
      ))
    }

@delegate:ResourceContentHash(-1_759_874_129)
internal val Res.string.nav_addtree_confirmation: StringResource by lazy {
      StringResource("string:nav_addtree_confirmation", "nav_addtree_confirmation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3159, 68),
      ))
    }

@delegate:ResourceContentHash(-2_122_258_561)
internal val Res.string.nav_addtree_confirmation_first_here: StringResource by lazy {
      StringResource("string:nav_addtree_confirmation_first_here", "nav_addtree_confirmation_first_here", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3031, 127),
      ))
    }

@delegate:ResourceContentHash(-920_910_232)
internal val Res.string.nav_addtree_photo_upload_failed: StringResource by lazy {
      StringResource("string:nav_addtree_photo_upload_failed", "nav_addtree_photo_upload_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3228, 151),
      ))
    }

@delegate:ResourceContentHash(-748_633_750)
internal val Res.string.nav_auth_context_addtree: StringResource by lazy {
      StringResource("string:nav_auth_context_addtree", "nav_auth_context_addtree", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3380, 156),
      ))
    }

@delegate:ResourceContentHash(-258_572_694)
internal val Res.string.nav_auth_context_createharvest: StringResource by lazy {
      StringResource("string:nav_auth_context_createharvest", "nav_auth_context_createharvest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3537, 94),
      ))
    }

@delegate:ResourceContentHash(1_894_594_232)
internal val Res.string.nav_auth_context_favorites: StringResource by lazy {
      StringResource("string:nav_auth_context_favorites", "nav_auth_context_favorites", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3632, 86),
      ))
    }

@delegate:ResourceContentHash(1_510_729_140)
internal val Res.string.nav_auth_context_login: StringResource by lazy {
      StringResource("string:nav_auth_context_login", "nav_auth_context_login", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3719, 66),
      ))
    }

@delegate:ResourceContentHash(-2_030_873_935)
internal val Res.string.nav_auth_context_profile: StringResource by lazy {
      StringResource("string:nav_auth_context_profile", "nav_auth_context_profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3786, 108),
      ))
    }

@delegate:ResourceContentHash(-1_487_984_276)
internal val Res.string.nav_tab_explore: StringResource by lazy {
      StringResource("string:nav_tab_explore", "nav_tab_explore", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3895, 35),
      ))
    }

@delegate:ResourceContentHash(1_886_018_066)
internal val Res.string.nav_tab_favorites: StringResource by lazy {
      StringResource("string:nav_tab_favorites", "nav_tab_favorites", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3931, 37),
      ))
    }

@delegate:ResourceContentHash(-1_957_023_911)
internal val Res.string.nav_tab_harvests: StringResource by lazy {
      StringResource("string:nav_tab_harvests", "nav_tab_harvests", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3969, 36),
      ))
    }

@delegate:ResourceContentHash(-478_899_239)
internal val Res.string.nav_tab_profile: StringResource by lazy {
      StringResource("string:nav_tab_profile", "nav_tab_profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4006, 31),
      ))
    }

@delegate:ResourceContentHash(-1_688_982_173)
internal val Res.string.nav_tree_deleted: StringResource by lazy {
      StringResource("string:nav_tree_deleted", "nav_tree_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4038, 60),
      ))
    }

@delegate:ResourceContentHash(-70_764_033)
internal val Res.string.notifications_empty_message: StringResource by lazy {
      StringResource("string:notifications_empty_message", "notifications_empty_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4099, 143),
      ))
    }

@delegate:ResourceContentHash(398_890_794)
internal val Res.string.notifications_empty_title: StringResource by lazy {
      StringResource("string:notifications_empty_title", "notifications_empty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4243, 61),
      ))
    }

@delegate:ResourceContentHash(1_104_521_496)
internal val Res.string.notifications_load_more: StringResource by lazy {
      StringResource("string:notifications_load_more", "notifications_load_more", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4305, 47),
      ))
    }

@delegate:ResourceContentHash(997_662_890)
internal val Res.string.notifications_mark_all_read: StringResource by lazy {
      StringResource("string:notifications_mark_all_read", "notifications_mark_all_read", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4353, 63),
      ))
    }

@delegate:ResourceContentHash(33_666_278)
internal val Res.string.notifications_preferences_action: StringResource by lazy {
      StringResource("string:notifications_preferences_action", "notifications_preferences_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4417, 80),
      ))
    }

@delegate:ResourceContentHash(1_871_104_415)
internal val Res.string.notifications_title: StringResource by lazy {
      StringResource("string:notifications_title", "notifications_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4498, 39),
      ))
    }

@delegate:ResourceContentHash(-98_997_167)
internal val Res.string.notifprefs_categories_heading: StringResource by lazy {
      StringResource("string:notifprefs_categories_heading", "notifprefs_categories_heading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4538, 53),
      ))
    }

@delegate:ResourceContentHash(-1_640_738_394)
internal val Res.string.notifprefs_email_label: StringResource by lazy {
      StringResource("string:notifprefs_email_label", "notifprefs_email_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4592, 42),
      ))
    }

@delegate:ResourceContentHash(-1_826_576_068)
internal val Res.string.notifprefs_harvests_description: StringResource by lazy {
      StringResource("string:notifprefs_harvests_description", "notifprefs_harvests_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4635, 91),
      ))
    }

@delegate:ResourceContentHash(-1_957_023_911)
internal val Res.string.notifprefs_harvests_label: StringResource by lazy {
      StringResource("string:notifprefs_harvests_label", "notifprefs_harvests_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4727, 45),
      ))
    }

@delegate:ResourceContentHash(462_875_470)
internal val Res.string.notifprefs_inapp_description: StringResource by lazy {
      StringResource("string:notifprefs_inapp_description", "notifprefs_inapp_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4773, 104),
      ))
    }

@delegate:ResourceContentHash(-1_160_786_878)
internal val Res.string.notifprefs_inapp_label: StringResource by lazy {
      StringResource("string:notifprefs_inapp_label", "notifprefs_inapp_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4878, 46),
      ))
    }

@delegate:ResourceContentHash(-412_435_119)
internal val Res.string.notifprefs_maturity_description: StringResource by lazy {
      StringResource("string:notifprefs_maturity_description", "notifprefs_maturity_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4925, 155),
      ))
    }

@delegate:ResourceContentHash(10_890_609)
internal val Res.string.notifprefs_maturity_label: StringResource by lazy {
      StringResource("string:notifprefs_maturity_label", "notifprefs_maturity_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5081, 45),
      ))
    }

@delegate:ResourceContentHash(-53_939_113)
internal val Res.string.notifprefs_maturity_locked: StringResource by lazy {
      StringResource("string:notifprefs_maturity_locked", "notifprefs_maturity_locked", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5193, 58),
      ))
    }

@delegate:ResourceContentHash(-167_561_507)
internal val Res.string.notifprefs_maturity_locked_action: StringResource by lazy {
      StringResource("string:notifprefs_maturity_locked_action", "notifprefs_maturity_locked_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5127, 65),
      ))
    }

@delegate:ResourceContentHash(1_788_626_289)
internal val Res.string.notifprefs_push_label: StringResource by lazy {
      StringResource("string:notifprefs_push_label", "notifprefs_push_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5252, 53),
      ))
    }

@delegate:ResourceContentHash(-1_512_744_107)
internal val Res.string.notifprefs_push_not_available: StringResource by lazy {
      StringResource("string:notifprefs_push_not_available", "notifprefs_push_not_available", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5306, 105),
      ))
    }

@delegate:ResourceContentHash(1_159_452_750)
internal val Res.string.notifprefs_push_permission_denied: StringResource by lazy {
      StringResource("string:notifprefs_push_permission_denied", "notifprefs_push_permission_denied", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5412, 125),
      ))
    }

@delegate:ResourceContentHash(984_692_365)
internal val Res.string.notifprefs_push_registration_failed: StringResource by lazy {
      StringResource("string:notifprefs_push_registration_failed", "notifprefs_push_registration_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5538, 123),
      ))
    }

@delegate:ResourceContentHash(875_223_699)
internal val Res.string.notifprefs_push_unsupported: StringResource by lazy {
      StringResource("string:notifprefs_push_unsupported", "notifprefs_push_unsupported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5662, 95),
      ))
    }

@delegate:ResourceContentHash(33_666_278)
internal val Res.string.notifprefs_title: StringResource by lazy {
      StringResource("string:notifprefs_title", "notifprefs_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5758, 64),
      ))
    }

@delegate:ResourceContentHash(-1_285_826_728)
internal val Res.string.notifprefs_trees_description: StringResource by lazy {
      StringResource("string:notifprefs_trees_description", "notifprefs_trees_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5823, 76),
      ))
    }

@delegate:ResourceContentHash(-1_851_754_604)
internal val Res.string.notifprefs_trees_label: StringResource by lazy {
      StringResource("string:notifprefs_trees_label", "notifprefs_trees_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5900, 38),
      ))
    }

@delegate:ResourceContentHash(-1_493_026_795)
internal val Res.string.profile_delete_code_confirm: StringResource by lazy {
      StringResource("string:profile_delete_code_confirm", "profile_delete_code_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6006, 71),
      ))
    }

@delegate:ResourceContentHash(1_085_801_154)
internal val Res.string.profile_delete_code_confirm_submitting: StringResource by lazy {
      StringResource("string:profile_delete_code_confirm_submitting", "profile_delete_code_confirm_submitting", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5939, 66),
      ))
    }

@delegate:ResourceContentHash(1_412_082_876)
internal val Res.string.profile_delete_code_invalid_format: StringResource by lazy {
      StringResource("string:profile_delete_code_invalid_format", "profile_delete_code_invalid_format", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6078, 94),
      ))
    }

@delegate:ResourceContentHash(1_173_867_291)
internal val Res.string.profile_delete_code_invalid_or_expired: StringResource by lazy {
      StringResource("string:profile_delete_code_invalid_or_expired", "profile_delete_code_invalid_or_expired", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6173, 106),
      ))
    }

@delegate:ResourceContentHash(-1_702_300_502)
internal val Res.string.profile_delete_code_label: StringResource by lazy {
      StringResource("string:profile_delete_code_label", "profile_delete_code_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6280, 41),
      ))
    }

@delegate:ResourceContentHash(-1_120_297_004)
internal val Res.string.profile_delete_code_placeholder: StringResource by lazy {
      StringResource("string:profile_delete_code_placeholder", "profile_delete_code_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6322, 55),
      ))
    }

@delegate:ResourceContentHash(95_370_368)
internal val Res.string.profile_delete_code_resend: StringResource by lazy {
      StringResource("string:profile_delete_code_resend", "profile_delete_code_resend", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6378, 58),
      ))
    }

@delegate:ResourceContentHash(-654_757_155)
internal val Res.string.profile_delete_code_text: StringResource by lazy {
      StringResource("string:profile_delete_code_text", "profile_delete_code_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6437, 148),
      ))
    }

@delegate:ResourceContentHash(1_082_480_686)
internal val Res.string.profile_delete_code_title: StringResource by lazy {
      StringResource("string:profile_delete_code_title", "profile_delete_code_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6586, 65),
      ))
    }

@delegate:ResourceContentHash(-1_290_138_280)
internal val Res.string.profile_delete_requesting_text: StringResource by lazy {
      StringResource("string:profile_delete_requesting_text", "profile_delete_requesting_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6652, 102),
      ))
    }

@delegate:ResourceContentHash(1_106_633_905)
internal val Res.string.profile_delete_requesting_title: StringResource by lazy {
      StringResource("string:profile_delete_requesting_title", "profile_delete_requesting_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6755, 63),
      ))
    }

@delegate:ResourceContentHash(-1_438_906_913)
internal val Res.string.profile_delete_warning_confirm: StringResource by lazy {
      StringResource("string:profile_delete_warning_confirm", "profile_delete_warning_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6819, 50),
      ))
    }

@delegate:ResourceContentHash(-951_455_507)
internal val Res.string.profile_delete_warning_text: StringResource by lazy {
      StringResource("string:profile_delete_warning_text", "profile_delete_warning_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6870, 263),
      ))
    }

@delegate:ResourceContentHash(174_147_878)
internal val Res.string.profile_delete_warning_title: StringResource by lazy {
      StringResource("string:profile_delete_warning_title", "profile_delete_warning_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7134, 68),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.profile_dialog_cancel: StringResource by lazy {
      StringResource("string:profile_dialog_cancel", "profile_dialog_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7203, 41),
      ))
    }

@delegate:ResourceContentHash(1_240_374_854)
internal val Res.string.profile_export_ready: StringResource by lazy {
      StringResource("string:profile_export_ready", "profile_export_ready", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7245, 84),
      ))
    }

@delegate:ResourceContentHash(-1_229_367_754)
internal val Res.string.profile_export_unsupported: StringResource by lazy {
      StringResource("string:profile_export_unsupported", "profile_export_unsupported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7330, 122),
      ))
    }

@delegate:ResourceContentHash(-1_376_287_478)
internal val Res.string.profile_favorites_plural: StringResource by lazy {
      StringResource("string:profile_favorites_plural", "profile_favorites_plural", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7453, 44),
      ))
    }

@delegate:ResourceContentHash(-2_054_018_826)
internal val Res.string.profile_favorites_singular: StringResource by lazy {
      StringResource("string:profile_favorites_singular", "profile_favorites_singular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7498, 42),
      ))
    }

@delegate:ResourceContentHash(-1_295_831_611)
internal val Res.string.profile_harvests_organized_plural: StringResource by lazy {
      StringResource("string:profile_harvests_organized_plural", "profile_harvests_organized_plural", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7541, 69),
      ))
    }

@delegate:ResourceContentHash(1_184_260_756)
internal val Res.string.profile_harvests_organized_singular: StringResource by lazy {
      StringResource("string:profile_harvests_organized_singular", "profile_harvests_organized_singular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7611, 71),
      ))
    }

@delegate:ResourceContentHash(-102_467_363)
internal val Res.string.profile_logout: StringResource by lazy {
      StringResource("string:profile_logout", "profile_logout", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8139, 42),
      ))
    }

@delegate:ResourceContentHash(1_370_859_918)
internal val Res.string.profile_logout_all: StringResource by lazy {
      StringResource("string:profile_logout_all", "profile_logout_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8068, 70),
      ))
    }

@delegate:ResourceContentHash(545_906_166)
internal val Res.string.profile_logout_all_dialog_confirm: StringResource by lazy {
      StringResource("string:profile_logout_all_dialog_confirm", "profile_logout_all_dialog_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7683, 57),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("favorites_add_label", Res.string.favorites_add_label)
  map.put("favorites_empty_cta", Res.string.favorites_empty_cta)
  map.put("favorites_empty_message", Res.string.favorites_empty_message)
  map.put("favorites_empty_title", Res.string.favorites_empty_title)
  map.put("favorites_remove_label", Res.string.favorites_remove_label)
  map.put("favorites_sites_title", Res.string.favorites_sites_title)
  map.put("favorites_title", Res.string.favorites_title)
  map.put("harvests_domain_note", Res.string.harvests_domain_note)
  map.put("harvests_find_tree_cta", Res.string.harvests_find_tree_cta)
  map.put("harvests_full", Res.string.harvests_full)
  map.put("harvests_hosted_by_owner", Res.string.harvests_hosted_by_owner)
  map.put("harvests_intro", Res.string.harvests_intro)
  map.put("harvests_open", Res.string.harvests_open)
  map.put("harvests_participants_cueilleur_plural", Res.string.harvests_participants_cueilleur_plural)
  map.put("harvests_participants_cueilleur_singular", Res.string.harvests_participants_cueilleur_singular)
  map.put("harvests_participants_with_max", Res.string.harvests_participants_with_max)
  map.put("harvests_place_clear_description", Res.string.harvests_place_clear_description)
  map.put("harvests_place_clear_query_description", Res.string.harvests_place_clear_query_description)
  map.put("harvests_place_empty_hint", Res.string.harvests_place_empty_hint)
  map.put("harvests_place_field_placeholder", Res.string.harvests_place_field_placeholder)
  map.put("harvests_place_selected", Res.string.harvests_place_selected)
  map.put("harvests_step1_body", Res.string.harvests_step1_body)
  map.put("harvests_step1_title", Res.string.harvests_step1_title)
  map.put("harvests_step2_body", Res.string.harvests_step2_body)
  map.put("harvests_step2_title", Res.string.harvests_step2_title)
  map.put("harvests_step3_body", Res.string.harvests_step3_body)
  map.put("harvests_step3_title", Res.string.harvests_step3_title)
  map.put("harvests_subtitle", Res.string.harvests_subtitle)
  map.put("harvests_title", Res.string.harvests_title)
  map.put("harvests_zone_map_center", Res.string.harvests_zone_map_center)
  map.put("harvests_zone_zoomed_out", Res.string.harvests_zone_zoomed_out)
  map.put("install_banner_action", Res.string.install_banner_action)
  map.put("install_banner_close", Res.string.install_banner_close)
  map.put("install_banner_subtitle", Res.string.install_banner_subtitle)
  map.put("install_banner_title", Res.string.install_banner_title)
  map.put("mytrees_empty_cta", Res.string.mytrees_empty_cta)
  map.put("mytrees_empty_message", Res.string.mytrees_empty_message)
  map.put("mytrees_empty_title", Res.string.mytrees_empty_title)
  map.put("mytrees_title", Res.string.mytrees_title)
  map.put("nav_addtree_confirmation", Res.string.nav_addtree_confirmation)
  map.put("nav_addtree_confirmation_first_here", Res.string.nav_addtree_confirmation_first_here)
  map.put("nav_addtree_photo_upload_failed", Res.string.nav_addtree_photo_upload_failed)
  map.put("nav_auth_context_addtree", Res.string.nav_auth_context_addtree)
  map.put("nav_auth_context_createharvest", Res.string.nav_auth_context_createharvest)
  map.put("nav_auth_context_favorites", Res.string.nav_auth_context_favorites)
  map.put("nav_auth_context_login", Res.string.nav_auth_context_login)
  map.put("nav_auth_context_profile", Res.string.nav_auth_context_profile)
  map.put("nav_tab_explore", Res.string.nav_tab_explore)
  map.put("nav_tab_favorites", Res.string.nav_tab_favorites)
  map.put("nav_tab_harvests", Res.string.nav_tab_harvests)
  map.put("nav_tab_profile", Res.string.nav_tab_profile)
  map.put("nav_tree_deleted", Res.string.nav_tree_deleted)
  map.put("notifications_empty_message", Res.string.notifications_empty_message)
  map.put("notifications_empty_title", Res.string.notifications_empty_title)
  map.put("notifications_load_more", Res.string.notifications_load_more)
  map.put("notifications_mark_all_read", Res.string.notifications_mark_all_read)
  map.put("notifications_preferences_action", Res.string.notifications_preferences_action)
  map.put("notifications_title", Res.string.notifications_title)
  map.put("notifprefs_categories_heading", Res.string.notifprefs_categories_heading)
  map.put("notifprefs_email_label", Res.string.notifprefs_email_label)
  map.put("notifprefs_harvests_description", Res.string.notifprefs_harvests_description)
  map.put("notifprefs_harvests_label", Res.string.notifprefs_harvests_label)
  map.put("notifprefs_inapp_description", Res.string.notifprefs_inapp_description)
  map.put("notifprefs_inapp_label", Res.string.notifprefs_inapp_label)
  map.put("notifprefs_maturity_description", Res.string.notifprefs_maturity_description)
  map.put("notifprefs_maturity_label", Res.string.notifprefs_maturity_label)
  map.put("notifprefs_maturity_locked", Res.string.notifprefs_maturity_locked)
  map.put("notifprefs_maturity_locked_action", Res.string.notifprefs_maturity_locked_action)
  map.put("notifprefs_push_label", Res.string.notifprefs_push_label)
  map.put("notifprefs_push_not_available", Res.string.notifprefs_push_not_available)
  map.put("notifprefs_push_permission_denied", Res.string.notifprefs_push_permission_denied)
  map.put("notifprefs_push_registration_failed", Res.string.notifprefs_push_registration_failed)
  map.put("notifprefs_push_unsupported", Res.string.notifprefs_push_unsupported)
  map.put("notifprefs_title", Res.string.notifprefs_title)
  map.put("notifprefs_trees_description", Res.string.notifprefs_trees_description)
  map.put("notifprefs_trees_label", Res.string.notifprefs_trees_label)
  map.put("profile_delete_code_confirm", Res.string.profile_delete_code_confirm)
  map.put("profile_delete_code_confirm_submitting", Res.string.profile_delete_code_confirm_submitting)
  map.put("profile_delete_code_invalid_format", Res.string.profile_delete_code_invalid_format)
  map.put("profile_delete_code_invalid_or_expired", Res.string.profile_delete_code_invalid_or_expired)
  map.put("profile_delete_code_label", Res.string.profile_delete_code_label)
  map.put("profile_delete_code_placeholder", Res.string.profile_delete_code_placeholder)
  map.put("profile_delete_code_resend", Res.string.profile_delete_code_resend)
  map.put("profile_delete_code_text", Res.string.profile_delete_code_text)
  map.put("profile_delete_code_title", Res.string.profile_delete_code_title)
  map.put("profile_delete_requesting_text", Res.string.profile_delete_requesting_text)
  map.put("profile_delete_requesting_title", Res.string.profile_delete_requesting_title)
  map.put("profile_delete_warning_confirm", Res.string.profile_delete_warning_confirm)
  map.put("profile_delete_warning_text", Res.string.profile_delete_warning_text)
  map.put("profile_delete_warning_title", Res.string.profile_delete_warning_title)
  map.put("profile_dialog_cancel", Res.string.profile_dialog_cancel)
  map.put("profile_export_ready", Res.string.profile_export_ready)
  map.put("profile_export_unsupported", Res.string.profile_export_unsupported)
  map.put("profile_favorites_plural", Res.string.profile_favorites_plural)
  map.put("profile_favorites_singular", Res.string.profile_favorites_singular)
  map.put("profile_harvests_organized_plural", Res.string.profile_harvests_organized_plural)
  map.put("profile_harvests_organized_singular", Res.string.profile_harvests_organized_singular)
  map.put("profile_logout", Res.string.profile_logout)
  map.put("profile_logout_all", Res.string.profile_logout_all)
  map.put("profile_logout_all_dialog_confirm", Res.string.profile_logout_all_dialog_confirm)
}
